export class Future<T> {
    // ========================================================================
    readonly promise: Promise<T>;
    #resolveFn!: (result: T) => void;
    #rejectFn!: (error: Error) => void;
    #settled = false;
    #result?: T;

    // ========================================================================
    constructor() {
        this.promise = new Promise((resolve, reject) => {
            this.#resolveFn = resolve;
            this.#rejectFn = reject;
        });
    }

    // ========================================================================
    get settled(): boolean {
        return this.#settled;
    }

    // ========================================================================
    finally(cbFn: () => void): Future<T> {
        this.promise.finally(cbFn);
        return this;
    }

    // ========================================================================
    catch(cbFn: (error: Error) => void): Future<T> {
        this.promise.catch(cbFn);
        return this;
    }

    // ========================================================================
    then(cbFn: (value: T) => void): Future<T> {
        this.promise.then(cbFn);
        return this;
    }

    // ========================================================================
    resolve(result: T): void {
        this.#settled = true;
        this.#result = result;
        this.#resolveFn(this.#result);
    }

    // ========================================================================
    reject(error: Error): void {
        this.#settled = true;
        this.#rejectFn(error);
    }
}
